import React, { Fragment, useContext, useState } from "react";

import { PropTypes } from "prop-types";

import CharsInput from "../../../react_utils/fields/CharsInput";
import CustomModal from "../../../react_utils/modals/CustomModal";
import ModalFooter from "../../../react_utils/modals/ModalFooter";
import { MessagingContext } from "../../MessagingContext";
import useModifyName from "../../../shared/hooks/common/useModifyName";

export default function ModifyNameModal({
  initial,
  editName,
  resetParent,
  modalProps = {},
}) {
  const { showMessage } = useContext(MessagingContext);
  const [isFocused, setIsFocused] = useState(false);

  const onToggle = (isOpen) => {
    setIsFocused(isOpen);
    modalProps.onToggle?.(isOpen);
  };

  const getFooter = (toggle) => {
    return (
      <ModalFooter
        buttons={[
          {
            label: "Speichern",
            onClick: () => onSubmit(toggle),
            disabled: !name.value,
          },
        ]}
      />
    );
  };

  const { onSubmit, name } = useModifyName(
    initial,
    editName,
    resetParent,
    showMessage,
    isFocused,
  );

  return (
    <Fragment>
      <CustomModal
        size="sm"
        title={"Name ändern"}
        getFooter={getFooter}
        {...modalProps}
        onToggle={onToggle}
      >
        <CharsInput
          label="Name"
          onChange={(v) => name.setValue(v)}
          value={name.value}
        />
      </CustomModal>
    </Fragment>
  );
}

ModifyNameModal.propTypes = {
  initial: PropTypes.string,
  editName: PropTypes.func,
  resetParent: PropTypes.func,
  modalProps: PropTypes.object,
};
